let storage = {};

export default class {
    static getItem(key) {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            return storage[key] ?? null;
        }
    }
    
    static setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            storage[key] = value;
        }
    }
    
    static removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            delete storage[key];
        }
    }
    
    static getItemAndRemove(key) {
        let buf = this.getItem(key);
        
        this.removeItem(key);
        
        return buf;
    }
    
    static clear() {
        try {
            localStorage.clear();
        } catch (e) {
            storage = {};
        }
    }
};
